import React, { useMemo } from 'react';
import { BsFunnel } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Icon,
  IconButton, Popover,
  PopoverArrow, PopoverBody,
  PopoverCloseButton, PopoverContent,
  PopoverHeader,
  PopoverTrigger, Portal, Radio, RadioGroup, Text,
  Tooltip
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { jobDetailsSearch } from '../../../../redux/reducer';

const RecordSortOrderButton = () => {
  const dispatch = useDispatch();
  const currentSortBy = useSelector(jobDetailsSearch.selectSortBy);
  const handleUpdateSortOrder = val => {
    dispatch(jobDetailsSearch.updateSortBy([
      { id: val, desc: false }
    ]));
  };

  const selectedSortBy = useMemo(() => {
    if (currentSortBy.length > 0) {
      return currentSortBy[0].id;
    }

    return 'insured';
  }, [currentSortBy]);

  return (
    <Popover
      placement="left-start"
    >
      {({ isOpen, onClose }) => (
        <>
          <Tooltip label="Filter Records">
            <Box>
              <PopoverTrigger>
                <IconButton
                  aria-label="Filter Records Button"
                  icon={<span><Icon as={BsFunnel} boxSize="24px" /></span>}
                  mr={4}
                  variant="accent"
                />
              </PopoverTrigger>
            </Box>
          </Tooltip>
          <Portal>
            <PopoverContent width="395px">
              <PopoverArrow />
              <PopoverCloseButton />
              <PopoverHeader px={6} py={4} textAlign="left">
                <Text color="greyScale.900" textStyle="bodyXxl500">
                  Filters
                </Text>
              </PopoverHeader>
              <PopoverBody pb={4} px={6} width="395px">
                <RadioGroup
                  alignItems="flex-start"
                  display="flex"
                  flexDirection="column"
                  value={selectedSortBy}
                  onChange={val => handleUpdateSortOrder(val)}
                >
                  <Radio my={1} value="insured">
                    <Text color="greyScale.900" textStyle="bodyMd">
                      Sort by Insured Name
                    </Text>
                  </Radio>
                  <Radio my={1} value="record_number">
                    <Text color="greyScale.900" textStyle="bodyMd">
                      Sort by Record Number
                    </Text>
                  </Radio>
                </RadioGroup>
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </>
      )}
    </Popover>
  );
};

RecordSortOrderButton.propTypes = {};

export default RecordSortOrderButton;
